module.exports = __webpack_public_path__ + "static/img/manual_ja_34.0feca57.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_34.png
// module id = bP9A
// module chunks = 4